import React from 'react';
import { useState } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import styles from './Navbar.module.css';

function Navbar() {
    const [isOpen, setIsOpen] = useState(false);
    const navigate = useNavigate();

    return (
        <div className={styles.navbar}>

            {/* Logo */}
            <NavLink to="/" className={styles.logo}>
                <img src="/images/oya-coincierge.png" alt="logo" width={100} className={styles.logoIcon} />
            </NavLink>

            <button
                className={`${styles.hamburger} ${isOpen ? styles.active : ""}`}
                onClick={() => setIsOpen(!isOpen)}
            >
                <span></span>
            </button>

            {/* Nav Links */}
            <ul
                className={`${styles.navLinks} ${isOpen ? styles.display : ""}`}
                onClick={() => setIsOpen(!isOpen)}
            >
                <li><NavLink to="/" className={({ isActive }) => isActive ? styles.active : ''}>Home</NavLink></li>
                <li><NavLink to="/services" className={({ isActive }) => isActive ? styles.active : ''}>Services</NavLink></li>
                <li><NavLink to="/about" className={({ isActive }) => isActive ? styles.active : ''}>About</NavLink></li>
                {/* <li><NavLink to="/blog" className={({ isActive }) => isActive ? styles.active : ''}>Blog</NavLink></li> */}
                <li><NavLink to="/contact" className={({ isActive }) => isActive ? styles.active : ''}>Contact</NavLink></li>
            </ul>

            {/* Actions */}
            <div
                className={`${styles.navActions} ${isOpen ? styles.show : ""}`}
                onClick={() => setIsOpen(!isOpen)}
            >
                <button className={styles.signIn}
                    onClick={() => {
                        setIsOpen(false);      // Close mobile menu
                        navigate('/login');    // 3. Navigate to login
                    }}
                >
                    Sign In
                </button>
                <button className={styles.joinBtn}
                    onClick={() => {
                        setIsOpen(false);      // Close mobile menu
                        navigate('/account');  // 4. Navigate to start of signup flow
                    }}
                >
                    Join
                </button>
            </div>

        </div>
    );
}

export default Navbar;